import { useQuery } from '@tanstack/react-query';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPageReportTypes: aiReportTypes.GetTypes = () => {
  return axios.get('/page-reports/types');
};

type QueryFnType = typeof getPageReportTypes;

export const useGetPageReportTypes = ({
  config = {},
}: { config?: QueryConfig<QueryFnType> } = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['page-report-types'],
    queryFn: () => getPageReportTypes(),
  });
};
